import { Colors, LabelHeight } from './types';

export const HEIGHT = 400;
export const DONUT_THICKNESS = 40;
export const INNER_RADIUS = 90;
export const OUTER_RADIUS = INNER_RADIUS + DONUT_THICKNESS;
export const OTHERS_LABEL = 'Others';
export const OTHERS_LABEL_BUFFER_ZONE = -140;
export const LABEL_HEIGHT: LabelHeight = 32;

export const COLORS: Colors[] = ['chart02', 'chart03', 'chart04', 'chart05'];
